import React, { useCallback, useEffect } from 'react'
import EcxSidebar from './components/EcxSidebar'
import EcxHeader from './components/EcxHeader'
import EcxOffcanvas from './components/EcxOffcanvas'
import { Outlet, useLocation } from 'react-router-dom'
import { useEyeconxStore } from '../../store/eyeconxStore'
import clinicService from '../../services/clinic.service'
import dashboardService from '../../services/dashboard.service'
import ClinicFeaturesLoader from '../../modules/clinicFeatures/ClinicFeaturesLoader'

function MainLayout() {
  const location = useLocation()
  const user = useEyeconxStore(state => state.user)
  const userInfo = useEyeconxStore(state => state.userInfo)
  const setUserInfo = useEyeconxStore(state => state.setUserInfo)
  const setDashboardCounts = useEyeconxStore(state => state.setDashboardCounts)
  const sidebarCollapsed = useEyeconxStore((state) => state.sidebarCollapsed);
  const userPanelOpen = useEyeconxStore((state) => state.userPanelOpen)
  const setUserPanelOpen = useEyeconxStore((state) => state.setUserPanelOpen)
    const isFullWidthPage = ['/dashboard', '/messages', '/articles', '/eye-draw', '/my-files', '/invoices', '/reports', '/pms-update-history', '/activity', '/cancellation-followups', '/patient-engagement', '/recalls', '/invalid-details', '/appointments', '/reputation', '/web-bookings', '/update-password', '/help', '/whats-new', '/settings/clinic', '/settings/features', '/settings/reminders', '/settings/users', '/settings/templates'].some((path) => location.pathname.endsWith(path))
        || location.pathname.startsWith('/patient-files')
        || location.pathname.startsWith('/optical-dispensary')
        || location.pathname.startsWith('/blast')
        || location.pathname.startsWith('/newsletter')
        || location.pathname.startsWith('/surveys')

  useEffect(() => {
    if (userInfo === null) {
      getUserInfo()
    }
  }, [])

  useEffect(() => {
    setUserPanelOpen(false)
  }, [location.pathname, setUserPanelOpen])

  const loadDashboardCounts = useCallback(async () => {
    if (!user?.clinicId) {
      return
    }

    try {
      const response = await dashboardService.getDashboardCounts(user.clinicId)
      setDashboardCounts(response.data || {})
    } catch (error) {
      console.error('Failed to load dashboard counts', error)
    }
  }, [setDashboardCounts, user?.clinicId])

  useEffect(() => {
    loadDashboardCounts()
  }, [loadDashboardCounts, location.pathname])

  const getUserInfo = () => {
    clinicService.getUserInfo(user.clinicId, user.ID)
      .then(res => {
        setUserInfo(res.data)
      })
      .catch(() => {})
  }

  return (
    <div className="d-flex ecx-layout" style={{ backgroundColor: '#fcfcfc' }}>
      <ClinicFeaturesLoader />
      <aside className={`ecx-sidebar d-none d-md-block ${sidebarCollapsed ? 'ecx-sidebar--collapsed' : ''}`}>
        <EcxSidebar collapsed={sidebarCollapsed} />
      </aside>

      <main className="ecx-main d-flex flex-column flex-grow-1 min-vh-100" style={{ minWidth: 0, height: '100vh', overflow: 'hidden' }}>
        <div className="flex-shrink-0" style={{ zIndex: 1000, backgroundColor: '#fff' }}>
          <EcxHeader />
        </div>

        <div className="ecx-main-content">
          <div className={isFullWidthPage ? 'h-100' : 'container-xxl h-100'}>
            <Outlet />
          </div>
        </div>
      </main>

      <EcxSidebar mobile collapsed={false} />
      <EcxOffcanvas show={userPanelOpen} handleClose={() => setUserPanelOpen(false)} />
    </div>
  )
}

export default MainLayout
